import { Component, Input } from '@angular/core';
import { Report } from '../../../models/reporting';

@Component({
    selector: 'reporting-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent {
    @Input() report: Report<'Consolidated' | 'Detailed'> = {} as Report<'Consolidated' | 'Detailed'>;
}
